// extracted by mini-css-extract-plugin
module.exports = {"Tailer":"Layout_Tailer__3Mo7x","onlySmallScreens":"Layout_onlySmallScreens__2UbS8"};